import { Platform, StyleSheet } from 'react-native';
import { theme } from '../theme';
/**
 * Cross-platform shadow. On web use boxShadow to avoid "shadow style props are deprecated" warning.
 */
export function shadowStyle(offsetW, offsetH, radius, opacity, color = theme.colors.shadow) {
    if (Platform.OS === 'web') {
        return {
            boxShadow: `${offsetW}px ${offsetH}px ${radius}px rgba(${theme.colors.shadowRgbChannel},${opacity})`,
        };
    }
    return {
        shadowColor: color,
        shadowOffset: { width: offsetW, height: offsetH },
        shadowOpacity: opacity,
        shadowRadius: radius,
    };
}
export const commonStyles = StyleSheet.create({
    errorText: {
        marginLeft: 10,
        fontSize: 12,
        color: theme.colors.dangerText,
    },
});
